<div class="dashboard-tile-loading"></div>